import { useApp } from '../../context/AppContext';

//import tags
import { Link } from 'react-router-dom';

//import components
import Address from '../dynamic/contact/Address';
import Phone from '../dynamic/contact/Phone';
import Email from '../dynamic/contact/Email';

//import resources
import Galaxy from '../../assets/images/galaxy.jpg';

//import locales
import { useTranslation } from "react-i18next";
import "../../i18n";

export default function Footer({locale}) {

    const { categories } = useApp();

    const { t } = useTranslation();

    return (
        <footer className='px-3 mt-12 pt-12 pb-3 bg-center bg-cover before:content-[""] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-slate-900/70 relative' style={{ backgroundImage: `url(${Galaxy})` }}>
            <div className='container mx-auto relative z-10'>
                <div className='grid grid-cols-12 gap-5'>
                    <div className='col-span-12 sm:col-span-6 lg:col-span-3'>
                        <div className='text-white border-b border-[var(--orange)] pb-2 w-fit upper'>{t('history')}</div>
                        <ul className='text-white mt-5 text-[13px] md:text-[14px] lg:text-sm'>
                            <li className='mb-1'>
                                <Link to={`/${locale}/about`}>{t('about_footer')}</Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/news`}>{t('news_guide')}</Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/contact`}>{t('contact')}</Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/partners`}>{t('partners')}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className='col-span-12 sm:col-span-6 lg:col-span-3'>
                        <div className='text-white border-b border-[var(--orange)] pb-2 w-fit upper'>{t('personal_info')}</div>
                        <ul className='text-white mt-5 text-[13px] md:text-[14px] lg:text-sm'>
                            <li className='mb-1'>
                                <Link to={`/${locale}/personal`}>
                                {t('change_and_return')}
                                </Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/delivery`}>
                                {t('terms')}
                                </Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/return`}>
                                {t('return')}
                                </Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/warranty`}>
                                {t('warranty')}
                                </Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/cookie`}>
                                {t('cookie')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className='col-span-12 sm:col-span-6 lg:col-span-3'>
                        <div className='text-white border-b border-[var(--orange)] pb-2 w-fit upper'>{t('support')}</div>
                        <ul className='text-white mt-5 text-[13px] md:text-[14px] lg:text-sm'>
                            <li className='mb-1'>
                                <Link to='https://www.youtube.com/@planetarium3970' target='_blank'>{t('video_reviews')}</Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`/${locale}/faq`}>{t('faq')}</Link>
                            </li>
                            <li className='mb-1'>
                                <Link to={`https://celestron.ge/${locale}/products/aksesuarebi`}>{t('accessories')}</Link>
                            </li>
                            {/* <li className='mb-1'>
                                <Link to={`/${locale}/faq`}>{t('warranty_info')}</Link>
                            </li> */}
                            <li className='mb-1'>
                                <Link to='https://instructions.planetarium.ge' target='_blank'>{t('about_telescope')}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className='col-span-12 sm:col-span-6 lg:col-span-3'>
                        <div className='text-white border-b border-[var(--orange)] pb-2 w-fit upper'>{t('contact_info')}</div>
                        <ul className='text-white mt-5 text-[13px] md:text-[14px] lg:text-sm'>
                            <li className='mb-1'>
                                <Address className='flex mb-5' />
                            </li>
                            <li className='mb-1'>
                                <Phone className='flex mb-5' />
                            </li>
                            <li className='mb-1'>
                                <Email className='flex' />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="text-center text-white mt-12 relative z-10">© 2025 <span className='text-[var(--orange)]'>Celestron</span>. {t('copyright')}</div>
        </footer>
    );
}